import { render, staticRenderFns } from "./TypesMultiselectWidget.vue?vue&type=template&id=52aa2b98&lang=pug&"
import script from "./TypesMultiselectWidget.vue?vue&type=script&lang=js&"
export * from "./TypesMultiselectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports